import { getFieldLabel } from "@/util/DataUtil";
export default {
  getHead: () => {
    return [{ name: getFieldLabel() }, { name: "재해형태" }, { name: "소속명" }, { name: "부서명" }, { name: "작성일" }];
  },
  getCol: (index, value, func) => {
    try {
      switch (index) {
        case 0:
          return func.getContent(value).stdInfo.field_name; // 학교(기관)명
        case 1:
          return func.getContent(value).stdInfo.재해형태; // 재해형태
        case 2:
          return func.getContent(value).stdInfo.department; // 소속명
        case 3:
          return func.getContent(value).stdInfo.section; // 부서명
        case 4:
          return func.getCreatedDate(value.created_at); // 작성일
      }
    } catch (e) {
      /*ignore*/
    }
    return "";
  },
  getSearchKeyValue: (nav) => {
    if (nav.value.created_at) {
      nav.dateTarget = "created_at";
      nav.dateBegin = "nav.value.created_at.sDate";
      nav.dateEnd = "nav.value.created_at.eDate";
    }
    return { disasterType: nav.value.disasterType, searchType: nav.value.searchType, searchKeyword: nav.value.searchKeyword };
  },
  getSearchKeyword: (nav) => {
    const returnData = [];

    if (nav.value.disasterType) returnData.push('content$body.stdInfo."재해형태"*[:default_disaster]');

    switch (nav.value.searchType) {
      case getFieldLabel():
        returnData.push("content$body.stdInfo.field_name*%[:default_skw]%");
        break;
      case "소속명":
        returnData.push("content$body.stdInfo.department*%[:default_skw]%");
        break;
      case "부서명":
        returnData.push("content$body.stdInfo.section*%[:default_skw]%");
        break;
    }

    return returnData;
  },
};
